const moment = require('moment-timezone');

// Safe localStorage read: returns a SAFE OBJECT so the chained deref never throws
// on an absent key, a "undefined" string, or malformed JSON. (Phase-2 S-A helper.)
export const safeParseLocal = (key, fallback = {}) => {
  try { const v = localStorage.getItem(key); return v == null ? fallback : JSON.parse(v); }
  catch (e) { return fallback; }
};


const dateConverterFromString = (date, domainTimeZone) => {
    let to;
    let from;
    switch (date) {

        case 'Today':
            from = moment().tz(domainTimeZone).startOf('day').toISOString();
            to = moment().tz(domainTimeZone).endOf('day').toISOString();
            break;
        case 'Yesterday':
            from = moment().tz(domainTimeZone).subtract(1,'d').startOf('day').toISOString();
            to = moment().tz(domainTimeZone).subtract(1,'d').endOf('day').toISOString();
            break;
        case 'This Week':
            from = moment().tz(domainTimeZone).startOf('isoWeek').isoWeekday(1).toISOString();
            to = moment().tz(domainTimeZone).endOf('day').toISOString();
            break;
        case 'Last Week':
            from = moment().tz(domainTimeZone).subtract(1,'weeks').startOf('isoWeek').toISOString();
            to = moment().tz(domainTimeZone).subtract(1,'weeks').endOf('isoWeek').toISOString();
            break;
        case 'Last 7 Days':
            from = moment().tz(domainTimeZone).subtract(7,'days').startOf('day').toISOString();
            to = moment().tz(domainTimeZone).endOf('day').toISOString();
            break;
        case 'Last 15 Days':
            from = moment().tz(domainTimeZone).subtract(15,'days').startOf('day').toISOString();
            to = moment().tz(domainTimeZone).endOf('day').toISOString();
            break;
        case 'Last 30 Days':
            from = moment().tz(domainTimeZone).subtract(30,'days').startOf('day').toISOString();
            to = moment().tz(domainTimeZone).endOf('day').toISOString();
            break;
        case 'This Month':
            from = moment().tz(domainTimeZone).startOf('month').toISOString();
            to = moment().tz(domainTimeZone).endOf('day').toISOString();
            break;
        case 'Last Month':
            from = moment().tz(domainTimeZone).subtract(1,'month').startOf('month').toISOString();
            to = moment().tz(domainTimeZone).subtract(1,'month').endOf('month').toISOString();
            break;
         case 'Last 60 Days':
            from = moment().tz(domainTimeZone).subtract(60,'days').startOf('day').toISOString();
            to = moment().tz(domainTimeZone).endOf('day').toISOString();
            break;
         case 'Last 90 Days':
            from = moment().tz(domainTimeZone).subtract(90,'days').startOf('day').toISOString();
            to = moment().tz(domainTimeZone).endOf('day').toISOString();
            break;
         case 'Last 180 Days':
            from = moment().tz(domainTimeZone).subtract(180,'days').startOf('day').toISOString();
            to = moment().tz(domainTimeZone).endOf('day').toISOString();
            break;
        case 'This Year':
            from = moment().tz(domainTimeZone).startOf('year').toISOString();
            to = moment().tz(domainTimeZone).endOf('day').toISOString();
            break;
        case 'Last Year':
            from = moment().tz(domainTimeZone).subtract(1,'year').startOf('year').toISOString();
            to = moment().tz(domainTimeZone).subtract(1,'year').endOf('year').toISOString();
            break;
        case 'Last 12 Months':
            from = moment().tz(domainTimeZone).subtract(365,'days').startOf('day').toISOString();
            to = moment().tz(domainTimeZone).endOf('day').toISOString();
            break;  
        case 'Last 6 Months':
            from = moment().tz(domainTimeZone).subtract(180,'days').startOf('day').toISOString();
            to = moment().tz(domainTimeZone).endOf('day').toISOString();
            break; 
        case 'Last 3 Months':
            from = moment().tz(domainTimeZone).subtract(90,'days').startOf('day').toISOString();
            to = moment().tz(domainTimeZone).endOf('day').toISOString();
            break;    
       
    }

	 return {to,from }

}

const previousDateConverterFromString = (date, domainTimeZone,to,from) => {//calculate previous date like current month is feb then previous month will be jan
    switch (date) {
        
        case 'Today':
            from = moment().tz(domainTimeZone).subtract(1,'d').startOf('day').toISOString();
            to = moment().tz(domainTimeZone).subtract(1,'d').endOf('day').toISOString();
            break;
        case 'Yesterday':
            from = moment().tz(domainTimeZone).subtract(2,'d').startOf('day').toISOString();
            to = moment().tz(domainTimeZone).subtract(2,'d').endOf('day').toISOString();
            break;
        case 'This Week':
            from = moment().tz(domainTimeZone).subtract(1,'weeks').startOf('isoWeek').toISOString();
            to = moment().tz(domainTimeZone).subtract(1,'weeks').endOf('isoWeek').toISOString();
            break;
        case 'Last Week':
            from = moment().tz(domainTimeZone).subtract(2,'weeks').startOf('isoWeek').toISOString();
            to = moment().tz(domainTimeZone).subtract(2,'weeks').endOf('isoWeek').toISOString();
            break;
        case 'This Month':
            from = moment().tz(domainTimeZone).subtract(1,'month').startOf('month').toISOString();
            to = moment().tz(domainTimeZone).subtract(1,'month').endOf('month').toISOString();
            break;
        case 'Last Month':
            from = moment().tz(domainTimeZone).subtract(2,'month').startOf('month').toISOString();
            to = moment().tz(domainTimeZone).subtract(2,'month').endOf('month').toISOString();
            break;
        case 'This Year':
            from = moment().tz(domainTimeZone).subtract(1,'month').startOf('year').toISOString();
            to = moment().tz(domainTimeZone).endOf('day').toISOString();
            break;
        case 'Last Year':
            from = moment().tz(domainTimeZone).subtract(1,'year').startOf('year').toISOString();
            to = moment().tz(domainTimeZone).subtract(1,'year').endOf('year').toISOString();
            break;
        default :
            let timeDiffrence = moment(to).diff(from, 'days');
            to = moment(from).subtract(1, 'days').startOf('day').tz(domainTimeZone).endOf('day').toISOString(),
            from =moment(to).tz(domainTimeZone).subtract(timeDiffrence, 'days').startOf('day').toISOString()
                
       
    }
    
	 return {to,from }

}

const setItemLocalStorage = (key, val) => {
    if(key == 'selected_domain'){
        var selected_domain = JSON.parse(val)
        if(selected_domain.subDomainProvider && selected_domain.subDomainProvider.length > 0){
            selected_domain.hybrid_o365_verified = ''
            selected_domain.hybrid_exchange_verified = ''
            selected_domain.subDomainProvider.map((subdomain)=>{
                if(subdomain.domain_provider == 2){
                    selected_domain.hybrid_o365_verified = subdomain.verified;
                }
                else if(subdomain.domain_provider == 4){
                    selected_domain.hybrid_exchange_verified = subdomain.verified;
                }
            }) 
            delete selected_domain.subDomainProvider;
        }
        
        localStorage.setItem(key, JSON.stringify(selected_domain));

    } 
    else{
        localStorage.setItem(key, val);
    }
}

const getDefaultPage = () => {
    let defaultPage = "dashboard";

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const perms = Array.isArray(user.permissions) ? user.permissions : [];
    if (perms.includes('reported_mails')) {
        defaultPage = "reported_mails";

    } else if (perms.length === 2 && perms.includes('settings')) {
        const settingIndex = perms.indexOf('settings');
        return getPagefromPer(settingIndex === 0 && perms[1] || perms[0]);

    } else if (perms.length === 1) {
        return getPagefromPer(perms[0]);

    } else {
        defaultPage = "dashboard";
    }
    return defaultPage;
}

const getPagefromPer = (permission) => {
    const defaultPage = "dashboard";
    const perPageMapping = {
        'settings_domain_login_user': 'admin_users'
    }
    return perPageMapping[permission] || defaultPage;
    
}

const getCurrentDateTime = () => {
    let selected_domain = JSON.parse(localStorage.getItem('selected_domain'));
    let domainTimeZone = selected_domain && selected_domain.timezone;
    return moment.tz(moment(), domainTimeZone).format('DD_MM_YYYY HH_mm');
}

export default {setItemLocalStorage, previousDateConverterFromString, dateConverterFromString,getDefaultPage, getCurrentDateTime}



// WEBPACK FOOTER //
// ./src/utils/common.js